<div class="center" style = " height: 100%">
    <mat-card class="cardcomponentMasks" style = "padding: 0px;">
        <div style = "top: 0; position: sticky; background-color: rgba(255, 255, 255, 0.96);z-index: 100; padding-top: 2%;"><button title="{{'labels.save' | translate}}" (click)="closeDialog()" style="float: right;" mat-icon-button color="warn" aria-label="icon-button save">
            <mat-icon>close</mat-icon>
        </button>
        <h3 class="titles" style="color: {{this.dashColor}}; text-align: left; margin-left: 2%">
            <mat-card-title><p>{{'labels.documentClass' | translate}}:</p></mat-card-title>
        </h3>
        <hr class="riga" style="color: {{this.dashColor}};">
        </div>
        <br>
        <mat-card-content>

            <!--hai cliccato la maschera con id: {{this.id}}-->
            <div style="display: flex" class="bigbox">
                <div style="width: 100%" class="tree">
                        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl"
                                  style="background: transparent;">
                            <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
                                <button mat-icon-button disabled></button>
                                <button mat-button (click)="docClassClick(node.item.substr(node.item.indexOf('#@')+2, node.item.length))"
                                >{{node.item.substr(0, node.item.indexOf('#@'))}}</button>
                            </mat-tree-node>
                            <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
                                <button mat-icon-button
                                        [attr.aria-label]="'Toggle ' + node.item" matTreeNodeToggle>
                                    <mat-icon class="mat-icon-rtl-mirror">
                                        {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                                    </mat-icon>
                                </button>
                                <ng-container
                                        *ngIf="node.item != this.translate.instant('labels.classList')"><button mat-button (click)="docClassClick(node.item.substr(node.item.indexOf('#@')+2, node.item.length))"
                                >{{node.item.substr(0, node.item.indexOf('#@'))}}</button></ng-container>
                                <ng-container
                                        *ngIf="node.item == this.translate.instant('labels.classList')">{{node.item}}</ng-container>

                            </mat-tree-node>
                        </mat-tree>
                </div>
            </div>


        </mat-card-content>

    </mat-card>
</div>
